let RepurchaseResponse = /*#__PURE__*/function (RepurchaseResponse) {
  RepurchaseResponse[RepurchaseResponse["OK"] = 0] = "OK";
  RepurchaseResponse[RepurchaseResponse["NO_REPURCHASE_POSSIBLE"] = 1] = "NO_REPURCHASE_POSSIBLE";
  RepurchaseResponse[RepurchaseResponse["CANNOT_COMPLETE_REPURCHASE"] = 2] = "CANNOT_COMPLETE_REPURCHASE";
  RepurchaseResponse[RepurchaseResponse["ZENDESK_FAILS"] = 3] = "ZENDESK_FAILS";
  RepurchaseResponse[RepurchaseResponse["SHIPMENT_IN_TRANSIT_OR_DELIVERED"] = 4] = "SHIPMENT_IN_TRANSIT_OR_DELIVERED";
  return RepurchaseResponse;
}({});

export { RepurchaseResponse };
//# sourceMappingURL=RepurchaseResponse.js.map
